/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SupportPhoneStatusRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {SupportPhoneStatusResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const supportPhoneStatus = (request:SupportPhoneStatusRequest, options?: CashRequestOptions) => post<SupportPhoneStatusRequest, SupportPhoneStatusResponse>("/cash-app/support-phone/status", request, {...options, rejectOnError: true })